import { render, staticRenderFns } from "./budget-program-info.vue?vue&type=template&id=3080754c&"
import script from "./budget-program-info.vue?vue&type=script&lang=ts&"
export * from "./budget-program-info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports